import BSTlogo from '../images/chain-logo.png';
import USDTimg from '../images/usdt.png';

export const blockstar_test = {
  id: 55,
  name: 'BlockStar TEST',
  network: 'blockstar-test',
  nativeCurrency: {
    decimals: 18,
    name: 'BlockStar',
    symbol: 'TBST',
  },
  rpcUrls: {
    public: { http: ['https://testnet-rpc.blockstar.one'] },
    default: { http: ['https://testnet-rpc.blockstar.one'] },
  },
  blockExplorers: {
    etherscan: { name: 'BlockStarScan', url: 'https://testnet-scan.blockstar.one' },
    default: { name: 'BlockStarScan', url: 'https://testnet-scan.blockstar.one' },
  },
  contracts: {
    multicall3: {
      address: '0xBF429308D450182B13afB96413ffc6855c3388C9',
      blockCreated: 12230,
    },
  },
}


export const blockstar = {
  id: 5512,
  name: 'BlockStar',
  network: 'blockstar',
  nativeCurrency: {
    decimals: 18,
    name: 'BlockStar',
    symbol: 'BST',
  },
  rpcUrls: {
    public: { http: ['https://mainnet-rpc.blockstar.one'] },
    default: { http: ['https://mainnet-rpc.blockstar.one'] },
  },
  blockExplorers: {
    etherscan: { name: 'BlockStarScan', url: 'https://scan.blockstar.one' },
    default: { name: 'BlockStarScan', url: 'https://scan.blockstar.one' },
  },
  contracts: {
    multicall3: {
      address: '0x3c9d85F5C95E40C52980a8648397ca6E7cfA7932',
      blockCreated: 12230,
    },
  },
}




export const CHAIN_INFO = {
  55: {
    name: "BlockStar TEST",
    rpc: "https://testnet-rpc.blockstar.one",
    chain_id: 55,
    symbol: "TBST",
    explorer: "https://testnet-scan.blockstar.one",
    multicall_address: "0xBF429308D450182B13afB96413ffc6855c3388C9",
    nft_master: "0x984dA6101Dc51cf2D18BA389610Db339B96e936A",
    default_nft: "0x5e621782C5940C678Be47118C101395aF142f630",
    nft_auction: "0x122bB68EC91169E792249524Ef8Fc3CDcF62f472",
    currency_support: [
      {
        name: "BlockStar Native Currency",
        symbol: "TBST",
        address: "0x0000000000000000000000000000000000000000",
        decimals: 18,
        img: BSTlogo
      },
      {
        name: "Tether USD",
        symbol: "USDT",
        address: "0x30dfAE567b86d06f81325e321c94Df003742bFF2",
        decimals: 18,
        img: USDTimg
      }
    ]
  },
  5512: {
    name: "BlockStar",
    rpc: "https://mainnet-rpc.blockstar.one",
    chain_id: 5512,
    symbol: "BST",
    explorer: "https://scan.blockstar.one",
    multicall_address: "0x3c9d85F5C95E40C52980a8648397ca6E7cfA7932",
    nft_master: "0xC1c2e665C6a6125EB6aA3FfC6B7d715756766e6B",
    default_nft: "0x548b5e3eeF7CdAD50C91075C2d820Eb3e2D56F97",
    nft_auction: "0xa8B6408C06e87F3cc73556FFf38F827bE30410F7",
    currency_support: [
      {
        name: "BlockStar Native Currency",
        symbol: "BST",
        address: "0x0000000000000000000000000000000000000000",
        decimals: 18,
        img: BSTlogo
      },
      // {
      //   name : "Tether USD",
      //   symbol : "USDT",
      //   address : "0x30dfAE567b86d06f81325e321c94Df003742bFF2",
      //   decimals : 18,
      //   img : USDTimg
      // }
    ]
  }
}


export const chains = [blockstar];
export const DEFAULT_CHAIN = 5512;
export const SUPPORTED_CHAIN = [5512]
export const PROJECT_ID = '27b9720018bf7f8740936e6a6eb28604';
export const BACKEND_URL = "https://nftapp.blockstar.kids/api/"
// export const BACKEND_URL = "http://localhost:1001/api/"

export const IPFS_URL = "https://alchemy.mypinata.cloud/ipfs/"


export const DEFAULT_IMAGES = {
  "profile": {
    banner: "QmdAbuNWL6z5huvTxCdFMqa5z9DXedwpiQjfx2QgcVoCYM",
    profile: "QmaFYXVg33pUcB69Cem9SHYrSAav5Z2VzBUQNiyGrh6W4G"
  },
  "collection": {
    banner: "QmZi3exD1DsxbHfgxKFfFRYbhec3CiqsKtcQaTiFkdET5k",
    profile: "QmYyh34WfZM5dq9nzZHRCmDWoRwWGnX4WdWbkph5yjBXx7"
  }
}

